<template>

    <router-link :to="'/invoice-detail/' + invoiceId" class="link black ph3 ph4-ns flex items-center bt b--light-gray justify-between pointer hover-bg-near-white">

        <!-- invoice details -->
        <div class="pv3">
            <div class="legal">Invoice ID: {{ invoiceId }}</div>
            <div>{{rentalDate | moment("MMM DD [at] h:mma")}}</div>
        </div>

        <!-- arrow -->
        <div><img style="width: 10px;" src="@/assets/img/icon_forward_simple_yellow.svg"/></div>

    </router-link>

</template>

<script>
export default {
    props: {
        invoiceId: {
            type: Number,
            required: true
        },
        rentalDate: {
            type: String
        }
    }
};
</script>
